import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ShopSection = () => {
  const [products, setProducts] = useState([]);
  const [grid, setGrid] = useState(false);
  const [active, setActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const navigate = useNavigate();

  // 📌 GOOGLE SHEET SUBMIT FUNCTION
  const sendToGoogleSheet = async (formData) => {
    try {
      const formBody = new URLSearchParams();
      for (const key in formData) {
        formBody.append(key, formData[key]);
      }

      await fetch(
        "https://script.google.com/macros/s/AKfycbx_lSRFwHvartXsihMjDrkGge79n4uT1L17B-9MRJhJ7QWfyiUO52ZvisN91B6QmtDn/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formBody.toString(),
        }
      );
    } catch (error) {
      console.error("Google Sheet Error:", error);
    }
  };

  // 📌 UPDATED DOWNLOAD SUBMIT HANDLER
  const handleDownload = (e) => {
    e.preventDefault();

    const form = e.target;

    const formData = {
      name: form[0].value,
      email: form[1].value,
      phone: form[2].value,
      model: form[3].value,
      date: form[4].value, // hidden date field
      timestamp: new Date().toISOString(),
    };

    sendToGoogleSheet(formData);

    setShowModal(false);
    setDownloading(true);
  };

  // Fetch products
  useEffect(() => {
    fetch("/assets/data/epson-product.json")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
      })
      .catch((err) => console.error("Error loading products:", err));
  }, []);

  // Show Thank You after 5 seconds
  useEffect(() => {
    if (downloading) {
      const timer = setTimeout(() => setShowThankYou(true), 5000);
      return () => clearTimeout(timer);
    }
  }, [downloading]);

  // Add to cart
  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart!`);
  };

  // Thank You screen
  if (downloading && showThankYou) {
    return (
      <div
        style={{
          backgroundColor: "#f5f5f5",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <img src="/assets/images/bg/epson-thanks.png" alt="Thank You" />
      </div>
    );
  }

  // Downloading screen
  if (downloading) {
    return (
      <div
        style={{
          backgroundColor: "#f5f5f5",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h4 style={{ marginBottom: "20px", fontWeight: "600" }}>
          Downloading Drivers...
        </h4>

        <div
          style={{
            position: "relative",
            height: "12px",
            backgroundColor: "#ddd",
            borderRadius: "8px",
            overflow: "hidden",
            width: "30%",
            marginBottom: "35px",
          }}
        >
          <div
            className="progress-animation"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: "30%",
              backgroundColor: "#0078d7",
              borderRadius: "8px",
              animation: "moveLoader 1.8s linear infinite",
            }}
          ></div>
        </div>

        <div
          style={{
            backgroundColor: "#fff",
            padding: "25px 30px",
            textAlign: "center",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <h5
            style={{
              color: "#0078d7",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            Please Be Patient
          </h5>
          <p style={{ color: "#333", fontSize: "15px" }}>
            We are preparing, downloading, and installing your driver. Please
            wait a moment while the process completes.
          </p>
        </div>
      </div>
    );
  }

  // Default Page
  return (
    <section className="shop">
      {/* Banner Section */}
      <div className="hp-banner-wrapper position-relative text-white">
        <img
          src="/assets/images/bg/printer.jpg"
          alt="Printer background"
          className="hp-banner-bg"
        />
        <div className="hp-banner-overlay"></div>

        <div className="container h-100 position-relative z-2">
          <div className="row align-items-center justify-content-between h-100">
            <div className="col-12 col-md-6 mb-5 mb-md-0">
              <h2 className="fw-bold mb-3 hp-banner-title text-white mb-20">
                Set Up Your Epson Printer
              </h2>
              <p
                className="mb-4 hp-banner-text"
                style={{ marginBottom: "30px" }}
              >
                Enter your Epson product name and model number to get the right
                Epson Smart software and drivers for you.
              </p>

              <div className="d-flex flex-column flex-sm-row gap-2 mt-30">
                <input
                  type="text"
                  className="form-control py-2 px-3 hp-input"
                  placeholder="Enter your product name here. Example: 'Envy, OfficeJet...'"
                />
              </div>

              <button
                className="btn btn-primary px-4 py-2 hp-btn"
                onClick={() => setShowModal(true)}
                style={{ background: "#084da5" }}
              >
                Next
              </button>
            </div>

            <div className="col-12 col-md-5 text-center">
              <img
                src="/assets/epson.png"
                alt="Epson Printer"
                className="img-fluid shadow-lg hp-main-img"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Info Section */}
      <div className="container container-lg mt-30">
        <div className="row align-items-center">
          <div className="col-sm-8">
            <p style={{ fontSize: "20px", color: "black" }}>
              Install Epson Smart software and drivers on each mobile device or
              computer you want to print from. Add the printer on the new
              device.
            </p>

            <p
              style={{
                fontSize: "20px",
                color: "black",
                marginTop: "12px",
              }}
            >
              Need additional help with setup? Visit{" "}
              <a href="#" style={{ color: "#084da5" }}>
                <strong>
                  <u>Epson Support</u>
                </strong>
              </a>
            </p>
          </div>
          <div className="col-sm-4 text-center">
            <img
              src="/assets/images/bg/epson.png"
              alt="Epson Printer"
              style={{ width: "50%", height: "auto" }}
            />
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
          onClick={(e) => {
            if (e.target.classList.contains("modal")) setShowModal(false);
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content brother-modal">
              <div className="modal-header justify-content-between align-items-center border-0">
                <img
                  src="/assets/epson.png"
                  alt="Epson"
                  className="brother-logo"
                />
              </div>

              <div className="modal-body text-center">
                <h5
                  className="modal-title mb-3 fw-bold"
                  style={{ color: "#084da5" }}
                >
                  Epson Driver Download & Installation Form
                </h5>
                <p className="text-muted mb-4">
                  Get the latest printer drivers for seamless performance.
                  Ensure your printer’s software is up to date by downloading
                  the correct drivers. Simply enter your details below and
                  access your driver instantly.
                </p>

                <form className="brother-form mt-20" onSubmit={handleDownload}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <input
                        type="text"
                        placeholder="Your Name"
                        className="form-control brother-input"
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="email"
                        placeholder="Your Email"
                        className="form-control brother-input"
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        placeholder="Your Phone"
                        className="form-control brother-input"
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        placeholder="Your Printer Model"
                        className="form-control brother-input"
                      />
                    </div>

                    {/* HIDDEN DATE FIELD */}
                    <input type="hidden" value={new Date().toLocaleString()} />
                  </div>

                  <button
                    type="submit"
                    className="btn brother-btn mt-20 w-100"
                    style={{ background: "#084da5" }}
                  >
                    Download
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Product Grid Section */}
      <div className="container container-lg mt-30 mb-40">
        <div className="row">
          <div className="col-lg-12">
            <div className="flex-between gap-16 flex-wrap mb-40">
              <span className="text-gray-900">
                Showing 1–{products.length} of {products.length} results
              </span>
            </div>

            <div className={`list-grid-wrapper ${grid && "list-view"}`}>
              <div className="row gy-4">
                {products.map((item) => {
                  const total = Math.floor(Math.random() * 50) + 10;
                  const sold = Math.floor(Math.random() * total);
                  const percent = Math.round((sold / total) * 100);
                  const rating = (Math.random() * 1 + 4).toFixed(1);
                  const reviews = Math.floor(Math.random() * 9000) + 1000;

                  return (
                    <div className="col-xl-2 col-lg-4 col-md-6" key={item.id}>
                      <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                        <Link
                          to={`/product/${item.id}`}
                          className="product-card__thumb flex-center rounded-8 position-relative"
                        >
                          <img
                            src={
                              item.imageUrl ||
                              "/assets/images/thumbs/product-two-img1.png"
                            }
                            alt={item.name}
                            className="w-auto"
                            style={{ width: "200px", borderRadius: "0.5rem" }}
                          />
                        </Link>

                        <div className="product-card__content mt-16">
                          <div className="flex-align gap-6">
                            <span className="text-xs fw-medium text-gray-500">
                              {rating}
                            </span>
                            <span className="text-15 fw-medium text-warning-600 d-flex">
                              <i className="ph-fill ph-star" />
                            </span>
                            <span className="text-xs fw-medium text-gray-500">
                              ({reviews.toLocaleString()} reviews)
                            </span>
                          </div>

                          <h6 className="title text-lg fw-semibold mt-12 mb-8">
                            <Link
                              to={`/product/${item.id}`}
                              className="link text-line-2"
                            >
                              {item.name}
                            </Link>
                          </h6>

                          <div className="flex-align gap-4">
                            <span className="text-tertiary-600 text-md d-flex">
                              <i className="ph-fill ph-storefront" />
                            </span>
                            <span className="text-gray-500 text-xs">
                              By Printing Dealz
                            </span>
                          </div>

                          <div className="mt-8">
                            <div
                              className="progress w-100 bg-color-three rounded-pill h-4"
                              role="progressbar"
                              aria-valuenow={percent}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <div
                                className="progress-bar bg-tertiary-600 rounded-pill"
                                style={{ width: `${percent}%` }}
                              />
                            </div>
                            <span className="text-gray-900 text-xs fw-medium mt-8">
                              Sold: {sold}/{total}
                            </span>
                          </div>

                          <div className="product-card__price my-20">
                            {item.oldPrice && (
                              <span className="text-gray-400 text-md fw-semibold text-decoration-line-through me-2">
                                ${item.oldPrice}
                              </span>
                            )}
                            <span className="text-heading text-md fw-semibold">
                              ${item.price}{" "}
                              <span className="text-gray-500 fw-normal">
                                /Qty
                              </span>
                            </span>
                          </div>

                          <button
                            onClick={() => {
                              handleAddToCart(item);
                              window.location.reload();
                            }}
                            className="product-card__cart btn bg-gray-50 hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                            style={{ width: "100%" }}
                          >
                            Add To Cart <i className="ph ph-shopping-cart" />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopSection;
